import {
  CLEAR_ERROR,
  CLEAR_SIDE_PANEL,
  CREATE_PATIENT_VISIT_REMARKS,
  CREATE_PATIENT_VISIT_REMARKS_ERROR,
  CREATE_PATIENT_VISIT_REMARKS_SUCCESS,
  DISABLE_SIDE_PANEL_LOADING,
  GET_PATIENT_VISIT_REMARKS,
  GET_PATIENT_VISIT_REMARKS_ERROR,
  GET_PATIENT_VISIT_REMARKS_SUCCESS,
  RESET_PATIENT_VISIT_REMARKS_UPDATED,
} from './PatientSidePanelConstants'
import { SET_ERROR } from '../waitingRoom/WaitingRoomConstants'
import { getUserFriendlyErrorMessage, errorCodes } from '../../utils/errormessages'
import {
  FORBIDDEN_ERROR,
  INTERNAL_SERVER_ERROR,
  MESSAGE_NOT_VALID_ERROR,
  VISIT_NOT_FOUND_ERROR,
} from '../../utils/constants'

const initialState = {
  loading: false,
  error: '',
  visitRemarks: [],
}

export const patientSidePanelReducer = (state = initialState, action = {}) => {
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  switch (action.type) {
    case GET_PATIENT_VISIT_REMARKS:
    case CREATE_PATIENT_VISIT_REMARKS:
      return {
        ...state,
        loading: true,
      }
    case GET_PATIENT_VISIT_REMARKS_SUCCESS:
      return {
        ...state,
        loading: false,
        visitRemarks: {
          ...state.visitRemarks,
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          [action.extraData.visitId]: [...action.payload],
        },
      }
    case RESET_PATIENT_VISIT_REMARKS_UPDATED:
      return {
        ...state,
        isUpdated: false,
      }
    case CREATE_PATIENT_VISIT_REMARKS_SUCCESS:
      const visitRemarksCopy =
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        state.visitRemarks?.[action.extraData.visitId] ?
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          JSON.parse(JSON.stringify(state.visitRemarks?.[action.extraData.visitId]))
        : null
      if (visitRemarksCopy) {
        // @ts-expect-error TS2488 -- MIGRATION: not approved, fix when encountered
        const newVisitRemarks = [...visitRemarksCopy, action.payload]
        return {
          ...state,
          visitRemarks: {
            ...state.visitRemarks,
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            [action.extraData.visitId]: newVisitRemarks,
          },
          loading: false,
          isUpdated: true,
        }
      }

      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      if (action.extraData.isForceUpdate) {
        return {
          ...state,
          isUpdated: true,
        }
      }

      return state
    case CREATE_PATIENT_VISIT_REMARKS_ERROR:
    case GET_PATIENT_VISIT_REMARKS_ERROR:
    case SET_ERROR:
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      if (action.payload.ErrorCode === MESSAGE_NOT_VALID_ERROR) {
        return {
          ...state,
          // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
          error: getUserFriendlyErrorMessage(errorCodes.NOT_VALID_VALUE, null, 'Remark message'),
          loading: false,
        }
      }
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      if (action.payload.ErrorCode === FORBIDDEN_ERROR) {
        return {
          ...state,
          // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
          error: getUserFriendlyErrorMessage(errorCodes.FORBIDDEN, null),
          loading: false,
        }
      }
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      if (action.payload.ErrorCode === VISIT_NOT_FOUND_ERROR) {
        return {
          ...state,
          // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
          error: getUserFriendlyErrorMessage(errorCodes.NOT_FOUND, null, 'The visit'),
          loading: false,
        }
      }
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      if (action.payload.ErrorCode === INTERNAL_SERVER_ERROR) {
        return {
          ...state,
          error: getUserFriendlyErrorMessage(errorCodes.DEFAULT),
          loading: false,
        }
      }
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      if (action.payload.ErrorCode === errorCodes.FILL_ALL_FIELDS) {
        return {
          ...state,
          error: getUserFriendlyErrorMessage(errorCodes.FILL_ALL_FIELDS),
          loading: false,
        }
      }
      return {
        ...state,
        error: '',
        loading: false,
      }
    case CLEAR_SIDE_PANEL:
      return {
        ...initialState,
      }
    case CLEAR_ERROR:
      return {
        ...state,
        error: '',
        loading: false,
      }

    case DISABLE_SIDE_PANEL_LOADING:
      return {
        ...state,
        loading: false,
      }
    default: {
      return state
    }
  }
}
